<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="1">
          <el-step title="空运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div style="display: flex;
         display: -webkit-flex; align-items: center">
          <img src="../../assets/style.png" alt="增值服务" />
          <p
            style="
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-left: 10px;
            "
          >
            增值服务
          </p>
        </div>

        <div class="Item_list" v-for="(item, index) in feeList" :key="index" @click="getIndex(index)">
          <div style="width: 100%;display: flex;justify-content:space-between;">
          
              <el-checkbox v-model="item.checked" @change="selectHandler(index)">{{
              item.feeName
            }}</el-checkbox>
              
              <div style="text-align:right;color:#999;margin:10px 0;">
                <span v-if="item.remark && item.checked">{{item.remark}}</span>
              </div>

          </div>
           
          <div
            
            style="width: 100%;"
            v-show="item.checked"
          >
             <div style="display:flex;justify-content:space-between;width:100%;  align-items: center;">
                  <div style="display:flex;align-items:center; box-sizing: border-box"
                  >
                    <span style="">{{ item.priceDesc }}</span>
                    <div style=" margin-left: 15px">
                      <el-input-number v-if="!checkType(item.feeCode)"
                        size="mini"
                        v-model="item.num"
                        @change="handleChange(item)"
                        :min="1"
                        :max="9999"
                      ></el-input-number>

                     <div class="changeElInput" v-if="checkType(item.feeCode)"
                     style="border-radius:5px;padding:5px;border: 1px solid #eee;
                     display: inline-block;">
                        <el-select size="mini" style="width:80px"
                         @change="handleChange(),getIndex(index)"
                         v-model="item.currency" placeholder="请选择币种">
                          <el-option 
                           
                            v-for="(rateDTOS,rateDTOSIndex) in item.rateDTOS"
                            :key="rateDTOSIndex"
                            :label="rateDTOS.currencyTo"
                            :value="rateDTOS.currencyTo">
                          </el-option>
                        </el-select>
                        <el-input  placeholder="请输入货值"
                         v-model="item.num" size="mini"
                          @change="handleChange(),getIndex(index)"
                         style="display: inline-block;
                         border-left: 1px solid #eee;width:150px"></el-input>
                     </div>
                    </div>
                  </div>

                  <div style="box-sizing: border-box">
                    预估费用：{{ item.currency }}{{ item.amount }}
                  </div>
             </div>
                         <div style="text-align:right;color:#999;margin:0px 0;">{{item.feeName}}服务手续{{item.amount2}}</div>
          </div>
        </div>

        <div v-show="feeList.length == 0" style="padding: 20px">
          <el-alert
            :closable="false"
            title="该线路暂无增值服务"
            type="warning"
            description="该线路暂无增值服务，请点击下一步继续操作"
            show-icon
          >
          </el-alert>
        </div>
      </div>

       <feeDetail
        :auto_fixed="auto_fixed"
        :allMoreFeeInfo="allMoreFeeInfo"
        :transportFeeForAir="transportFeeForAir"
        :pickFeeForAir="pickFeeForAir"
        :sendFeeForAir="sendFeeForAir"
        :currencyCollection="currencyCollection"
        :calculatePrice="calculatePrice"
        :feeList="feeList"
        ref="feeList"
        @pathToback="pathToback"
        @pathToNext="pathToNext"
      ></feeDetail>

    </div>
  </div>
</template>

<script>
import feeDetail from "./component/fee-detail.vue";
export default {
  components:{
    feeDetail
  },
  data() {
    return {
      allMoreFeeInfo:{
        "amount":0,
        "totalExpense":"0",
        "feeItemDTOS":[]
      },
      feeList: [],
      auto_fixed: false,
      transportFeeForAir: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      sendFeeForAir: {
        checked: false,
        name: "配送费",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      pickFeeForAir: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
      },
      index:'',
    };
  },
  watch:{
    feeList:{
       handler:function(val,oldval){
          // console.log(val)
          this.$refs.feeList.getHeight(this.index)
        },
        deep:true//对象内部的属性监听，也叫深度监听
    }
  },
  computed: {
    //折合人民币
    calculatePrice() {
      let Totalmoney = 0; //总费用
      let sendFeeForAir = 0; //配送费
      let transportFeeForAir = 0; //海运费
      let THFmoney = 0; //提货费
      transportFeeForAir = this.transportFeeForAir.cnyamount
        ? this.transportFeeForAir.cnyamount
        : 0;
      if (this.sendFeeForAir.checked) {
        //如果有配送费
        sendFeeForAir = this.sendFeeForAir.cnyprice
          ? this.sendFeeForAir.cnyprice
          : 0;
      }
      if (this.pickFeeForAir.checked) {
        //如果有提货费
        THFmoney = this.pickFeeForAir.cnyamount
          ? this.pickFeeForAir.cnyamount
          : 0;
      }

      if (transportFeeForAir) {
        Totalmoney += parseFloat(transportFeeForAir);
      }
      if (sendFeeForAir) {
        Totalmoney += parseFloat(sendFeeForAir);
      }
      if (THFmoney) {
        Totalmoney += parseFloat(THFmoney);
      }
      // 增值服务
      if (this.allMoreFeeInfo.amount > 0) {
        Totalmoney += parseFloat(this.allMoreFeeInfo.amount);
      }

      return Totalmoney.toFixed(2);
    },
    // 获得全部费用的币种
    currencyCollection() {
      let currencyAllIn = {};
    // 提货
      if (this.pickFeeForAir.currency && this.pickFeeForAir.checked) {
              if (currencyAllIn[this.pickFeeForAir.currency] === undefined) {
                currencyAllIn[this.pickFeeForAir.currency] = 0;
                currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
                  this.pickFeeForAir.amount
                );
              } else {
                currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
                  this.pickFeeForAir.amount
                );
              }
      }
      // 发货
      if (this.sendFeeForAir.currency && this.sendFeeForAir.checked) {
              if (currencyAllIn[this.sendFeeForAir.currency] === undefined) {
                currencyAllIn[this.sendFeeForAir.currency] = 0;
                currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
                  this.sendFeeForAir.amount
                );
              } else {
                currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
                  this.sendFeeForAir.amount
                );
              }
      }

      // 运费
    
      if (this.transportFeeForAir.currency) {
              if (currencyAllIn[this.transportFeeForAir.currency] === undefined) {
                currencyAllIn[this.transportFeeForAir.currency] = 0;
                currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
                  this.transportFeeForAir.amount
                );
              } else {
                currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
                  this.transportFeeForAir.amount
                );
              }
      }

      // 模拟增值服务
      // let temp = [
      //   { amount: 12, currency: "USD" },
      //   { amount: 32, currency: "USD" },
      //   { amount: 32, currency: "HKD" },
      //   { amount: 32, currency: "HKD" },
      // ];
     
      let temp = this.allMoreFeeInfo.feeItemDTOS
      temp.forEach((item, index) => {
        if(item.checked){
            if (currencyAllIn[item.currency] === undefined) {
              
          currencyAllIn[item.currency] = 0;
          currencyAllIn[item.currency] += item.amount;
        } else {
          currencyAllIn[item.currency] += item.amount;
        }
        }
        
      });


      let text = "";
      Object.keys(currencyAllIn).forEach((item) => {
        text += item + currencyAllIn[item].toFixed(2) + " + ";
      });

      return text.substring(0, text.length - 2);
    },
  },
  methods: {
    getIndex(index){
      
      setTimeout(() => {
          console.log(this. index = this.feeList[index].checked && index);
      }, 100);
    },
    // 检查费用代码是否显示下拉框
    checkType(feeCode){
        switch (feeCode) {
          case 'DDYF':
          return true
            break;
            case 'DDHK':
          return true
            break;
            case 'COD':
          return true
            break;
            case 'INS':
          return true
            break;
        }
        return false
    },
    pathToNext() {
      this.$router.push({
        name: "AirConsignment",
      });
    },
    // 勾选后赋值1 不然num没值报错
    selectHandler(index){
       this.feeList[index].num = 1
       this.handleChange()
    },
    //计算费用
    handleChange() {
     
      this.axios
        .post(`/KYFee/calKYFeeItems`, {
          customerId: this.sessionGetUserInfo()
            .customerid, //客户id
          feeItemDTOS: this.feeList,
          inWarehouseId: JSON.parse(sessionStorage.getItem("cangkuitem")).id,
        })
        .then((res) => {
           if (res.data.code == "200") {
            if (res.data.data.feeItemDTOS.length) {
              this.feeList = res.data.data.feeItemDTOS;
              this.allMoreFeeInfo = res.data.data;
              sessionStorage.setItem("moreFeeListForAir",JSON.stringify(this.allMoreFeeInfo))
            }else{
              this.$message.info("没有相关服务");
              
            }
            
          } else {
              this.$message.info(res.data.message || "服务器繁忙");
          }

        })
        .catch((res) => {});
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },

    pathToback() {
      this.$router.go(-1);
    },
    getFeeList() {
      let params = {};
      params = {
        customerId: this.sessionGetUserInfo()
          .customerid, //客户id
        inWarehouseId: JSON.parse(sessionStorage.getItem("cangkuitem")).id,
      };
      this.axios
        .post(`/KYFee/getKYFeeItems`, params)
        .then((res) => {
          if (res.data.code == "200") {
            if(res.data.datas.length){
              this.feeList = res.data.datas
            }else{
              this.$message.info("没有相关增值服务");
            }
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {});
    },

    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    if (sessionStorage.getItem("transportFeeForAir")) {
      //运输费
      this.transportFeeForAir = JSON.parse(
        sessionStorage.getItem("transportFeeForAir")
      );
    }
    if (sessionStorage.getItem("sendFeeForAir")) {
      this.sendFeeForAir = JSON.parse(sessionStorage.getItem("sendFeeForAir"));
    }
    if (sessionStorage.getItem("pickFeeForAir")) {
      this.pickFeeForAir = JSON.parse(sessionStorage.getItem("pickFeeForAir"));
    }
    if (sessionStorage.getItem("moreFeeListForAir")) {
      this.feeList = JSON.parse(sessionStorage.getItem("moreFeeListForAir")).feeItemDTOS;
      this.allMoreFeeInfo = JSON.parse(sessionStorage.getItem("moreFeeListForAir"));
      // this.handleChange()
    }else {
      this.getFeeList();
    }
  },
  mounted() {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
  },
};
</script>
<style scoped>
.changeElInput >>> .el-input__inner{
  border: none;
}
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 880px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}

.Item_Right {
  float: left;
  overflow-x: hidden;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}

.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-x: hidden;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1200px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 15px 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 870px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 35px;
  box-sizing: border-box;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/AirMoreService.vue